import { useForm } from 'react-hook-form';
import {
  GenerateOfficeDoctorAttendingAccountingFormValues,
  generateOfficeDoctorAttendingAccountingFormResolver,
} from './schema';

export type GenerateOfficeDoctorAttendingAccountingUseForm = ReturnType<
  typeof useForm<GenerateOfficeDoctorAttendingAccountingFormValues>
>;

export const useGenerateOfficeDoctorAttendingAccountingUseForm = (
  defaultValues?: Partial<GenerateOfficeDoctorAttendingAccountingFormValues>,
) => {
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11
  const currentYear = now.getFullYear();

  const generateOfficeDoctorAttendingAccountingForm =
    useForm<GenerateOfficeDoctorAttendingAccountingFormValues>({
      resolver: generateOfficeDoctorAttendingAccountingFormResolver,
      defaultValues: {
        accountingMonth: currentMonth,
        accountingYear: currentYear,
        ...defaultValues,
      },
    });

  return { generateOfficeDoctorAttendingAccountingForm };
};
